import React from 'react';
import Link from 'next/link';
import AspectRatioBox from '@components/shared/AspectRatioBox/AspectRatioBox';
import getResizedImageUrl from '@components/havenly/lib/getResizedImageUrl';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import {
  CardSize,
} from '@components/shared/DiscoverCard/util';
import styles from './TopicLinksCard.module.scss';

interface IExploreTopic {
  slug: string;
  name: string;
  imageUrl: string;
}

interface ITopicLinkCard {
  topics: IExploreTopic[];
  size: CardSize;
}

const getResizedImage = (imageUrl: string) => getResizedImageUrl({
  url: imageUrl,
  height: '200',
  width: '600',
  quality: 25,
});

const handleClick = (topic: IExploreTopic) => {
  analyticsTrack(
    'explore_topic_link_clicked',
    {
      slug: topic.slug,
      name: topic.name,
    },
  );
};

const getAspectRatio = (size:CardSize) => {
  switch (size) {
    case 'small': {
      return 1;
    }
    case 'medium': {
      return 2.04; // fudging it slightly to fit the templates
    }
    default: {
      return 1;
    }
  }
};

const TopicLinksCard = ({ topics, size }: ITopicLinkCard) => (
  // @ts-ignore
  <AspectRatioBox aspectRatio={ getAspectRatio(size) }>
    <div className={styles.TopicLinksWrapper}>
      { topics.map((topic: any) => (
        <Link key={topic.slug} href={`/exp/${topic.slug}`}>
          <a
            className={styles.TopicLink}
            href={`/exp/${topic.slug}`}
            onClick={() => handleClick(topic)}
            style={{
              backgroundImage: `url('${getResizedImage(topic.imageUrl)}')`,
            }}
          >
            <div className={styles.TopicLinkLabel}>
              {topic.shortName}
            </div>
            <div className={ `${styles.Overlay}` } />
          </a>
        </Link>
      ))}
    </div>
  </AspectRatioBox>
);

export default TopicLinksCard;
